import { call, put } from 'redux-saga/effects';
import {
  sendContactUsEmailFailure,
  sendContactUsEmailSuccess,
} from '../actions';
import { ApiError, ApiResponse } from 'store/api/types';
import { SendContactUsEmailRequestAction } from '../types';
import { checkResponse } from 'store/utils';
import { sendContactUsEmail } from '../api';
import { turnMessageOn } from 'store/app/actions';
import { MessageData } from 'store/app/types';
import { renderErrorMessage } from 'utils/render-error-message';
import { MessageStates } from 'containers/MessageBox';
import i18n from 'i18next';

/* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
export function* sendContactUsEmailSaga(
  action: SendContactUsEmailRequestAction
) {
  try {
    let err: ApiError | null;
    const { contactUs } = action.payload;

    const sendContactUsEmailResponse: ApiResponse = yield call(
      sendContactUsEmail,
      contactUs
    );

    err = checkResponse(sendContactUsEmailResponse?.responseMessage);
    if (err) throw err;

    yield put(sendContactUsEmailSuccess());
    const message: MessageData = {
      title: i18n.t('common.success-exclamation'),
      description: sendContactUsEmailResponse?.responseMessage.message,
      type: MessageStates.SUCCESS,
    };

    yield put(turnMessageOn(message));
  } catch (error: any) {
    const message: MessageData | null = renderErrorMessage(error);
    if (message) {
      yield put(turnMessageOn(message));
    }
    yield put(sendContactUsEmailFailure());
  }
}
